<template>
  <v-content>
    <v-container >
      <v-row v-if="showForm" align='center' justify='center'>
        <v-col cols='12' sm='8' md='4' >
          <v-spacer></v-spacer>
          <v-form ref='form' v-model='valid' lazy-validation v-on:submit.prevent >
            <v-text-field shaped v-model='username' :rules='usernameRules' label='E-mail' required validate-on-blur @keyup.enter='submit'></v-text-field>
            <v-spacer></v-spacer>
            <div class='float-right' >
            <v-btn :loading='btnLoader' :disabled='!valid' class='mr-4 bgclr whitefontcolor' @click='submit'>Reset Password</v-btn>
            </div>
            <v-spacer style='clear:both;' ></v-spacer>
          </v-form>
        </v-col>
      </v-row>
      <h1 v-else class="title" >
        Reset password email has been sent to your email.
        <v-spacer></v-spacer>
        Please check your email for further details.
      </h1>
    </v-container>
  </v-content>
</template>

<script>
import CONSTANTS from './../../../config/constant'
import ENV_CONSTANTS from './../../../config/envVariables'

export default {
  name: 'AdminForgotPassword',
  data: () => ({
    btnLoader: false,
    showForm: true,
    username: null,
    valid: true,
    usernameRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
    ]
  }),
  methods: {
    submit () {
      this.btnLoader = true
      const credentials = {
        username: this.username,
        rpLnk: ENV_CONSTANTS.RESET_PASSWORD_BASE_LINK // reset password link
      }
      if (credentials.username === null) {
        this.btnLoader = false
        this.$globalStates.notification.type = 'error'
        this.$globalStates.notification.text = CONSTANTS.VALID_USERNAME_ERROR_MESSAGE
        this.$globalStates.notification.init_notifications = true
      } else {
        new Promise((resolve, reject) => {
          this.$store.dispatch('AuthModule/forgotPassword', { resolve, reject, credentials })
        }).then(responseData => {
          this.btnLoader = false
          this.showForm = false
          this.$globalStates.notification.type = 'green'
          this.$globalStates.notification.text = responseData.responseMessage
          this.$globalStates.notification.init_notifications = true
        }).catch(response => {
          this.btnLoader = false
          this.$globalStates.notification.type = 'error'
          this.$globalStates.notification.text = response.responseMessage
          this.$globalStates.notification.init_notifications = true
        })
      }
    }
  }
}
</script>

<style scoped>
</style>
